export default (theme) => ({
  paragraph: {
    padding: 0,
    margin: 0,
    marginBottom: 10,
    // color: theme.palette.type === 'dark' ? 'white' : 'black',
  },
});
